var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav", { staticClass: "panel", staticStyle: { width: "100%" } }, [
    _c("p", { staticClass: "panel-heading filters-heading" }, [
      _c(
        "span",
        { staticClass: "clear-filters", on: { click: _vm.clearFilters } },
        [_vm._v("Clear")]
      ),
    ]),
    _c("div", { staticClass: "panel-block" }, [
      _vm._v(" " + _vm._s(_vm.filteredMarkers.length) + " markers "),
    ]),
    _c("div", { staticClass: "panel-block" }, [
      _c(
        "div",
        { staticClass: "control" },
        [
          _c("label", { staticClass: "label" }, [_vm._v("Types")]),
          _vm._l(_vm.types, function (type) {
            return _c(
              "b-field",
              { key: type },
              [
                _c(
                  "b-checkbox",
                  {
                    attrs: { "native-value": type },
                    model: {
                      value: _vm.typeCheckboxGroup,
                      callback: function ($$v) {
                        _vm.typeCheckboxGroup = $$v
                      },
                      expression: "typeCheckboxGroup",
                    },
                  },
                  [_vm._v(" " + _vm._s(type) + " ")]
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
    ]),
    _vm.showEnduserSubTypes
      ? _c("div", { staticClass: "panel-block" }, [
          _c("div", { staticClass: "control" }, [
            _c("label", { staticClass: "label" }, [_vm._v("KATR2")]),
            _c(
              "div",
              { staticClass: "checkbox-group" },
              _vm._l(_vm.enduserTypes, function (etype) {
                return _c(
                  "b-field",
                  { key: etype, staticClass: "is-block" },
                  [
                    _c(
                      "b-checkbox",
                      {
                        attrs: { "native-value": etype },
                        model: {
                          value: _vm.enduserTypeCheckboxGroup,
                          callback: function ($$v) {
                            _vm.enduserTypeCheckboxGroup = $$v
                          },
                          expression: "enduserTypeCheckboxGroup",
                        },
                      },
                      [_vm._v(" " + _vm._s(etype) + " ")]
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "panel-block" }, [
      _c(
        "div",
        { staticClass: "control" },
        [
          _c(
            "b-field",
            { attrs: { label: "Search" } },
            [
              _c(
                "b-autocomplete",
                {
                  attrs: {
                    placeholder: "enter name or id",
                    data: _vm.filteredMarkers,
                    icon: "search",
                    field: "name",
                  },
                  on: { select: _vm.handleMarkerSelection },
                  model: {
                    value: _vm.name,
                    callback: function ($$v) {
                      _vm.name = $$v
                    },
                    expression: "name",
                  },
                },
                [
                  _c("template", { slot: "empty" }, [
                    _vm._v(" No results found "),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }